<template>
  <div>
    <div class="modal" id="passwordModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div id="passwordModalContent" class="modal__content modal__content--MD">
        <div class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200">
          <h2 class="font-medium text-base mr-auto">
              ACTUALIZAR CONTRASEÑA <br> <!-- <app-title-custom></app-title-custom> -->
          </h2>
        </div>
        <form @submit.prevent="updatePassword" enctype="multipart/form-data" class="form-task">
          <div v-for="error in errors" :key="error">
            <p class="px-5 py-2 grid text-red-700 font-extrabold">{{error}}</p>
          </div>
          <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
            <div class="col-span-12 sm:col-span-12">
                <label>CONTRASEÑA</label>
                <input type="password" class="input w-full border mt-2 flex-1" v-model="form.password" required>
            </div>
            <div class="col-span-12 sm:col-span-12">
                <label>REPETIR CONTRASEÑA</label>
                <input type="password" class="input w-full border mt-2 flex-1" v-model="form.password_confirmation" required>
            </div>
          </div>
          <div class="px-5 py-3 text-right border-t border-gray-200">
              <button type="submit" class="button bg-theme-1 text-white">Actualizar</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ModalPasswordUpdated',
  data () {
    return {
      loading: false,
      form: {
        password: null,
        password_confirmation: null,
        entity: 'user',
        update_password: true,
      },
      errors: [],
    }
  },
  methods: {
    updatePassword() {
      var vm = this
      vm.loading = false
      this.form.id = this.user.id
      vm.update(vm.form).then(item => {
        vm.loading = true
        vm.form = { entity: 'user' }
        window.location.reload()
      })
      .catch(message => {
        vm.loading = true
        vm.errors = message.response.data.errors.password
      })
    },
    ...mapActions(['update'])
  },
    computed: {
    ...mapGetters({user: 'getUser'}),
    }
}
</script>

<style lang="">
  #passwordModal {
    visibility: initial;
    opacity: unset;
    z-index: 100000000000;
    margin: unset;
    display: flex
  }

  #passwordModalContent {
    margin-top: auto;
    margin-bottom: auto
  }

</style>



// WEBPACK FOOTER //
// ModalPasswordUpdated.vue?43592124